import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import Menu from 'antd/lib/menu'
import Dropdown from 'antd/lib/dropdown'
import Icon from 'antd/lib/icon'

import l8n, { prefixPath } from 'l8n';

const mapStateToProps = (state) => ({
  locale: state.app.locale
})

@connect(mapStateToProps)
class LocaleDropdown extends React.Component {
  render() {
    const languages = (
      <Menu>
        {_.keys(l8n.locales).map(function(locale){
          const qaId = 'locale-dropdown-' + locale;
          
          return (
            <Menu.Item key={locale}>
              <a href={prefixPath('/', locale)} data-qa-id={qaId}>{l8n.localeNames[locale]}</a>
            </Menu.Item>
          )
        })}
      </Menu>
    );
    return (
      <Dropdown overlay={languages} className="menuTop__navigation">
        <a className="ant-dropdown-link" href="javascript: void(0);">
          {l8n.localeNames[this.props.locale.value]} <Icon type="down" />
        </a>
      </Dropdown>
    )
  }
}

export default LocaleDropdown



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Localization/LocaleDropdown/index.js